import PropTypes from "prop-types";
import { createContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import OrganizationSwithStorageKeys from "../../constant/organizationSwitchStorageKeys";
import { organizationSwitchDialogStorage } from "../../helpers/organizationSwitchDialogStorage";

export const organizationSwitchContext = createContext(null);

const { Provider } = organizationSwitchContext;

const STORAGE_KEY = OrganizationSwithStorageKeys.organizationSwitch;

const getStoredData = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

const storeData = (data) => localStorage.setItem(STORAGE_KEY, JSON.stringify(data || {}));

const OrganizationSwitchProvider = ({ userId, children }) => {
  const [userData, setUserData] = useState(() => {
    if (!userId) return { activeId: null, recentIds: [] };

    const key = String(userId);
    const data = getStoredData()[key] || {};

    return {
      activeId: data.activeId ?? null,
      recentIds: data.recentIds ?? []
    };
  });

  const [haveShownDialog, setHaveShownDialogState] = useState(() => organizationSwitchDialogStorage.get());

  useEffect(() => {
    if (!userId) {
      setUserData({ activeId: null, recentIds: [] });
      return;
    }

    const key = String(userId);
    const data = getStoredData()[key] || {};

    setUserData({
      activeId: data.activeId ?? null,
      recentIds: data.recentIds ?? []
    });
  }, [userId]);

  const saveSelection = (userId, id, remember) => {
    if (!userId)
      return;

    const obj = getStoredData();
    const key = String(userId);
    const stored = obj[key] || {};

    const recent = stored.recentIds ?? [];

    const updatedRecent = remember
      ? [id, ...recent.filter(x => x !== id)].slice(0, 4)
      : recent;

    const updatedUserData = {
      activeId: id,
      recentIds: updatedRecent
    };

    obj[key] = updatedUserData;

    storeData(obj);
    setUserData(updatedUserData);
  };

  const persistHaveShownDialog = (value) => {
    organizationSwitchDialogStorage.set(value);
    setHaveShownDialogState(value);
  };

  const confirmHaveShownDialog = () => {
    persistHaveShownDialog(true);
  };

  const selectActiveOrganization = (id, remember) => {
    saveSelection(userId, id, remember);
    persistHaveShownDialog(true);
  };

  return (
    <Provider
      value={{
        activeId: userData.activeId,
        confirmHaveShownDialog,
        haveShownDialog,
        selectActiveOrganization,
        recentIds: userData.recentIds
      }}
    >
      {children}
    </Provider>
  );
};

OrganizationSwitchProvider.propTypes = {
  children: PropTypes.node.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

OrganizationSwitchProvider.defaultProps = {
  userId: null
};

const mapStateToProps = (state) => ({
  userId: state.api.currentViewer.viewer?.userId
});

export default connect(mapStateToProps)(OrganizationSwitchProvider);
